import { ModuleWithProviders, NgModule } from '@angular/core';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { NCatalogUi } from './df-catalog-ui.config';

@NgModule()
export class DfCatalogUiModule {
    static forRoot(config?: DeepPartial<NCatalogUi.IModuleOptions>): ModuleWithProviders<DfCatalogUiModule> {
        return {
            ngModule: DfCatalogUiModule,
            providers: [
                {
                    provide: NCatalogUi.OPTIONS,
                    useFactory: () => defaultsDeep(config, NCatalogUi.DEFAULT_OPTIONS)
                }
            ]
        };
    }
}
